
// http://localhost:3000/#modalacceder
// https://ecommerce-api-nuxtbo.herokuapp.com
const HostApi = "https://ecommerce-api-nuxtbo.herokuapp.com/api/v0.1/";


const urlNewClient ={
    // loging
    UrlLogin : HostApi + 'user/login',
    UrlNewUser : HostApi + 'user/new',

    UrlListNegocios : HostApi + 'negocio/list/for/idowner=',
    UrlUpdataDataNegocio : HostApi + 'negocio/update/data/idnegocio=',
    UrlCreateNegocio : HostApi + 'negocio',
    UrlUploadFielLogo : HostApi + 'negocio/upload/file=logo/idnegocio=',
    UrlUploadFileFotoTienda : HostApi + 'negocio/upload/file=fotolugar/idnegocio=',
    UrlDetailTienda: HostApi + 'negocio/detail/idOwner=',
                                    // "/product/show/list/all/idnegocio=:idnegocio&order=:order"
    UrlShowListAllProducts : HostApi + '/product/show/list/all/idnegocio=',
    UrlUpdateDataProduct : HostApi + 'product/update/data/idproducto=',
    UrlUplodFileImageProduct : HostApi  + 'product/upload/fotoproduct/file=fotoproducto4/idproducto=',
                            //  'product/upload/fotoproduct/file=fotoproducto/idproducto=6071b23e4143fe1394e3b28e'
                            // localhost:9000/api/v0.1/product/upload/fotoproduct/file=fotoproducto/idproducto=60722520a218c216f4008583
    UrlUpladFileForNameImage : HostApi + 'product/upload/fotoproduct/file=',
                                          //product/upload/fotoproduct/file=fotoproducto/idproducto=6071b23e4143fe1394e3b28e
    UrlCreateProduct : HostApi + '/product/create/idnegocio=',

    // show porducts
                                       // http://localhost:9000/api/v0.1/product/show/list/all/idnegocio=608b33b655fb720b783d8d08&order=asc
    UrlShowAllProductsTienda : HostApi + 'product/show/list/all/idnegocio=',

    // show list porducts recent sdded 
                                        //   /product/showlist/recente/added/limit=:limit&skip=:skip
    UrlShowProductAddedRecnet : HostApi + '/product/showlist/recente/added/limit=',
    UrlUpdateSateProduct : HostApi + '/product/update/idproduct=',

    // payment control use 
    UrlshowPaymetnCotrol : HostApi + '/payment/control/show/idnegocio='

}



export default urlNewClient;